import {Context, useContext} from "react";

export function useGetContext<T>(
  context: Context<T | null>,
  contextName?: string
): T {
  if (!context) {
    throw new Error(`${contextName || "Context"} is not provided.`);
  }
  const currentContext = useContext(context);
  if (!currentContext) {
    throw new Error(`${contextName || "Context"} is not provided.`);
  }
  return currentContext;
}
